import React from 'react';
import * as Sentry from '@sentry/react';
import ErrorIcon from '@mui/icons-material/Error';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {theme} from '../Theme';

type Props = $TSFixMe;
type State = $TSFixMe;

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      message: (props as $TSFixMe).message || 'Something went wrong.',
    };
  }

  static getDerivedStateFromError(error: $TSFixMe) {
    // Update state so the next render will show the fallback UI.
    return {hasError: true};
  }

  componentDidCatch(error: $TSFixMe, errorInfo: $TSFixMe) {
    Sentry.captureException(error);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      if (
        (this.props as $TSFixMe).fallbackUi === null ||
        (this.props as $TSFixMe).fallbackUi
      ) {
        return (this.props as $TSFixMe).fallbackUi;
      }
      return (
        <Box
          p={1.5}
          m={1}
          style={{border: `1px solid ${theme.palette.red.main}`}}>
          <Grid container alignItems="center">
            <ErrorIcon
              fontSize="large"
              style={{color: theme.palette.red.main, marginRight: 12}}
            />
            <Typography
              variant="subtitle1"
              style={{color: theme.palette.red.dark}}>
              {this.state.message} This error has been reported.
            </Typography>
          </Grid>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
